import { RootState } from 'store';

export const ordersSelector = (state: RootState) => state.orders.orders;
export const ordersLoadingSelector = (state: RootState) => state.orders.loading;
export const ordersErrorSelector = (state: RootState) => state.orders.error;
export const ordersDeliverySelector = (state: RootState) => state.orders.delivery;
export const newOrdersAmountSelector = (state: RootState) => state.orders.newOrdersAmount;
export const ordersOpenedSelector = (state: RootState) => state.orders.ordersOpened;